import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { CapaQuotationPartnerStrategyFile } from '@generated/graphql';
import CustomizedSwiper from '@components/Customized/CustomizedSwiper';
import { clsx } from '@components/Provider';
import useMediaSwiper from '../useMediaSwiper';

interface MediaSwiperMobileProps {
  initialSlide: number;
  files: CapaQuotationPartnerStrategyFile[];
  isOne: boolean;
}

const MediaSwiperMobile = ({
  initialSlide,
  files,
  isOne
}: MediaSwiperMobileProps) => {
  const { fractionTop, mobileSwiperSlide } = useStyles();
  const {
    useSwipeSlides,
    handleIframePointerEvent,
    handleStopVideo
  } = useMediaSwiper();

  const SwipeSlides = useSwipeSlides(files, clsx(mobileSwiperSlide));

  return (
    <Box
      width={'100%'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      position={'relative'}
    >
      {!isOne && (
        <Box
          position={'absolute'}
          width={'fit-content'}
          height={'fit-content'}
          top={0}
          left={'50%'}
          right={'50%'}
          className={clsx('pagination-fraction-top', fractionTop)}
        />
      )}

      <Box
        maxWidth={'100%'}
        padding={`48px 0px 0`}
        overflow={'hidden'}
        height={'100vh'}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'cetner'}
      >
        <CustomizedSwiper
          slidesPerView={1}
          initialSlide={initialSlide}
          pagination={{
            type: 'fraction',
            el: '.pagination-fraction-top'
          }}
          loop={!isOne}
          onSliderFirstMove={(swiper) => {
            handleStopVideo(swiper.slides[swiper.activeIndex]);
          }}
          onTransitionEnd={(swiper) => {
            handleIframePointerEvent(swiper.slides[swiper.activeIndex], 'auto');
          }}
          onSlideChange={(swiper) =>
            handleStopVideo(swiper.slides[swiper.previousIndex])
          }
        >
          {SwipeSlides}
        </CustomizedSwiper>
      </Box>
    </Box>
  );
};

export default MediaSwiperMobile;

const useStyles = makeStyles(() => ({
  mobileSwiperSlide: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100vh - 48px)',
    maxHeight: 500,
    padding: '0 16px',
    '& img,video': {
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    },
    '& iframe': {
      margin: `0 57px`
    }
  },
  fractionTop: {
    transform: 'translate(-50%, 100%)',
    fontSize: 16,
    fontWeight: 500
  }
}));
